export interface MatterSearchFilters {
  contactName?: string[];
  connectionLabel?: string;
  incidentAddress?: string[];
  incidentAddressCity?: string[];
  incidentAddressState?: string[];
  [filter: string]: string[] | string | undefined;
}

// Ensures client name filters are paired with the required contact label.
export const ensureClientLabelFilter = (
  filters: MatterSearchFilters,
): MatterSearchFilters => {
  const clientNames = filters.contactName;
  if (!clientNames?.length) {
    return filters;
  }
  return {
    ...filters,
    connectionLabel: "Client",
  };
};
